<template>
    <div class="grid grid-cols-1 gap-5" v-if="tranche.details && tranche.details.summary">
        <k-panel v-if="tranche.details.summary.dealStructure">
            <template v-slot:header>
                <k-panel-header>
                    Deal structure
                </k-panel-header>
            </template>
            <p class="leading-7" style="white-space: pre-line;">{{ tranche.details.summary.dealStructure }}</p>
        </k-panel>
    </div>
</template>

<script>
export default {
    props: {
        tranche: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>
